// src/sot/primitives/CoverPhoto.jsx
import React from "react";

export default function CoverPhoto({
  src,
  children,
  imageClassName = "",
  overlayClassName = "",
  heightClassName = "h-[190px] sm:h-[220px] md:h-[280px] lg:h-[320px]",
  onImageError,
}) {
  const safeSrc = src || "/assets/images/doctor_cover-placeholder.png";

  return (
    <div className="w-full bg-transparent">
      <div className="relative overflow-hidden rounded-none md:rounded-b-[12px]">
        {/* lock height across breakpoints */}
        <div className={["relative w-full overflow-hidden", heightClassName].filter(Boolean).join(" ")}>
          <img
            src={safeSrc}
            alt=""
            className={[
              "absolute inset-0 h-full w-full object-cover",
              imageClassName,
            ]
              .filter(Boolean)
              .join(" ")}
            draggable="false"
            onError={onImageError}
          />
          {overlayClassName ? (
            <div
              className={["absolute inset-0 pointer-events-none", overlayClassName]
                .filter(Boolean)
                .join(" ")}
              aria-hidden="true"
            />
          ) : null}
        </div>

        {/* Avatar slot */}
        {children ? (
          <div className="absolute left-4 top-1/2 -translate-y-1/2">
            {children}
          </div>
        ) : null}
      </div>
    </div>
  );
}
